"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBranding = exports.BrandingProvider = exports.BrandingContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
exports.BrandingContext = (0, react_1.createContext)({});
const BrandingProvider = (props) => {
    const { branding, children } = props;
    const logoUri = (0, react_1.useMemo)(() => (branding === null || branding === void 0 ? void 0 : branding.logoUri) ? branding.logoUri : 'https://jup.ag/svg/jupiter-logo.svg', [branding === null || branding === void 0 ? void 0 : branding.logoUri]);
    const name = (0, react_1.useMemo)(() => (branding === null || branding === void 0 ? void 0 : branding.name) ? branding.name : 'Jupiter', [branding === null || branding === void 0 ? void 0 : branding.name]);
    return (0, jsx_runtime_1.jsx)(exports.BrandingContext.Provider, { value: { logoUri, name }, children: children });
};
exports.BrandingProvider = BrandingProvider;
function useBranding() {
    const context = (0, react_1.useContext)(exports.BrandingContext);
    return context;
}
exports.useBranding = useBranding;
